import { createTheme, ThemeProvider } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import { TextField } from "@mui/material";

type SelectItem = {
  value: string;
  label?: string;
  disabled?: boolean;
  [key: string]: any;
};

type TProps = {
  id: string;
  formik: any;
  label?: string;
  disabled?: boolean;
  isClearable?: boolean;
  isLoading?: boolean;
  options: (string | SelectItem)[] | null;
};

const SelectDropdown = ({
  id,
  formik,
  label,
  options,
  isClearable = true,
  isLoading = false,
  disabled = false,
  ...props
}: TProps) => {
  return (
    <ThemeProvider theme={createTheme({})}>
      <TextField
        fullWidth
        select
        id={id}
        name={id}
        label={label}
        variant="standard"
        onBlur={formik.handleBlur}
        onChange={(event) => formik.setFieldValue(id, event.target.value)}
        value={formik.values[id] || ""}
        error={!!formik.touched[id] && !!formik.errors[id]}
        helperText={!!formik.touched[id] && formik.errors[id]}
        disabled={disabled || isLoading}
        {...props}
      >
        {isLoading ? (
          <MenuItem disabled>
            <em>Loading...</em>
          </MenuItem>
        ) : (
          [
            // If isClearable is true, add a "None" option
            isClearable && (
              <MenuItem key="none" value="">
                <em>None</em>
              </MenuItem>
            ),
            // Map through options and handle both string and object types
            ...(options || []).map((option, index) => {
              if (typeof option === "string") {
                return (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                );
              } else {
                return (
                  <MenuItem
                    key={index}
                    value={option.value}
                    disabled={option.disabled}
                  >
                    {option.label}
                  </MenuItem>
                );
              }
            }),
          ]
        )}
      </TextField>
    </ThemeProvider>
  );
};

export default SelectDropdown;
